import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TrashIcon from 'Containers/Icon/TrashIcon/TrashIcon';
export class AgTrashIcon extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const user = this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.user ? this.props.context.componentParent.props.user : undefined;
    const id = this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.id ? this.props.context.componentParent.props.id : undefined;
    if (id.includes("Un-Matched Scheme Images") || id.includes("Un-Matched Merchant Images")) {
      return (
        user && user.parsedPermissions && user.parsedPermissions.case &&
        user.parsedPermissions.case.deleteImageFromQueue &&
        <span key={this.props.node.rowIndex} className="image-icon">
          <TrashIcon height="20px" width="20px" />
        </span>
      );
    } else {
      return (
        <span key={this.props.node.rowIndex} className="image-icon">
          <TrashIcon height="20px" width="20px" />
        </span>
      );
    }
  }
}
AgTrashIcon.propTypes = {
  rowIndex: PropTypes.number,
  context: PropTypes.object,
};
export default AgTrashIcon;